import React from "react";
import formatDate from "../i18n/formatDate";

interface P extends React.HTMLAttributes<HTMLDivElement> {
  date: number;
  updateInterval?: number;
}

const DEFAULT_UPDATE_INTERVAL = 60000;

function RelativeDate({ date, updateInterval = DEFAULT_UPDATE_INTERVAL, ...props }: P) {
  const [, rerender] = React.useState({});

  React.useEffect(() => {
    const timer = window.setInterval(() => {
      rerender({});
    }, updateInterval);

    return () => {
      window.clearInterval(timer);
    };
  }, [date, updateInterval]);

  return (
    <div title={formatDate(date, "datetime", null)} {...props}>
      {formatDate(date, "relative", null)}
    </div>
  );
}

export default React.memo(RelativeDate);
